"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var Accordion_1 = __importDefault(require("@mui/material/Accordion"));
var AccordionSummary_1 = __importDefault(require("@mui/material/AccordionSummary"));
var AccordionDetails_1 = __importDefault(require("@mui/material/AccordionDetails"));
var colors_1 = require("../ThemeProvider/colors");
var colorManipulator_1 = require("../colorManipulator");
var Button_1 = __importDefault(require("../Button"));
var prism_icons_1 = require("@octanner/prism-icons");
var Accordion = (0, material_1.styled)(Accordion_1.default, { name: 'Accordion' })({
    flex: '1 1 auto',
    '&.MuiAccordion-root:before': {
        height: 0,
    },
    '&.MuiAccordion-root.Mui-expanded': {
        margin: 0,
    },
});
var SummaryContainer = (0, material_1.styled)('div', { name: 'SummaryContainer' })({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
});
var AccordionSummary = (0, material_1.styled)(AccordionSummary_1.default, {
    name: 'AccordionSummary',
})({
    '&.MuiButtonBase-root': {
        borderRadius: 4,
        fontSize: 14,
        marginTop: '3px',
        '&:hover': {
            backgroundColor: colors_1.tannerGray['50'],
        },
    },
    '&.MuiAccordionSummary-root': {
        minHeight: 40,
        padding: '0px 0px 0px 16px',
        '& svg': {
            transition: 'transform 200ms',
            marginRight: 16,
        },
        '&.Mui-expanded': {
            minHeight: 40,
            '& svg': {
                transform: 'rotate3d(0, 0, 1, 180deg)',
            },
        },
    },
    '& > .MuiAccordionSummary-content.Mui-expanded': {
        margin: '12px 0',
    },
});
var AccordionDetails = (0, material_1.styled)(AccordionDetails_1.default, {
    name: 'AccordionDetails',
})({
    '&.MuiAccordionDetails-root': {
        flexDirection: 'column',
        padding: '2px 0px 2px 16px',
        marginTop: '3px',
    },
});
var VerticalTab = function (_a) {
    var children = _a.children, label = _a.label, onClick = _a.onClick, _b = _a.selected, selected = _b === void 0 ? false : _b, expanded = _a.expanded, onChange = _a.onChange, _c = _a.adminColor, adminColor = _c === void 0 ? false : _c, _d = _a.labelVariant, labelVariant = _d === void 0 ? 'body1' : _d, testid = _a["data-testid"];
    var theme = (0, material_1.useTheme)();
    if (children)
        return (react_1.default.createElement(Accordion, { "data-testid": testid, elevation: 0, expanded: children
                ? typeof expanded === 'boolean'
                    ? expanded
                    : undefined
                : false, onClick: onClick, onKeyDown: function (e) {
                return onClick && e.key === 'Enter' && onClick();
            }, onChange: onChange },
            react_1.default.createElement(AccordionSummary, { focusRipple: true, disableRipple: false, disableTouchRipple: true, style: {
                    color: selected
                        ? (0, colorManipulator_1.lighten)(adminColor
                            ? colors_1.tannerSemantic['info'].color
                            : theme.palette.primary.main, 0.85)
                        : undefined,
                } },
                react_1.default.createElement(SummaryContainer, null,
                    react_1.default.createElement(material_1.Typography, { variant: labelVariant }, label),
                    ' ',
                    react_1.default.createElement(prism_icons_1.ArrowDown, null))),
            react_1.default.createElement(AccordionDetails, { "data-testid": "accordion-child-container" }, children)));
    return (react_1.default.createElement(Button_1.default, { "data-testid": "".concat(testid, "-button"), variant: "text", color: "inherit", sx: {
            justifyContent: 'flex-start',
            width: '100%',
            marginTop: '3px',
            borderWidth: 0,
            backgroundColor: selected
                ? colors_1.tannerSemantic['info'].background
                : 'inherit',
            '&:hover': {
                backgroundColor: colors_1.tannerGray['50'],
            },
        }, onClick: onClick, onKeyDown: function (e) {
            return onClick && e.key === 'Enter' && onClick();
        } },
        react_1.default.createElement(material_1.Typography, { sx: {
                color: selected ? colors_1.tannerSemantic['info'].color : 'inherit',
            } }, label)));
};
exports.default = VerticalTab;
//# sourceMappingURL=index.js.map